import { isFieldRestricted } from '../../../utils/fieldLevelPermissions';
import { useQuickFilterResolverAndOptions } from '../../../hooks/useQuickFilterResolverAndOptions';
import { useState } from 'react';
import ReferenceLiteSearchSelect from 'reference-resolvers-lite/components/ReferenceLiteSearchSelect';
import { jsx as _jsx } from "react/jsx-runtime";
const ExternalOptionEnumQuickFilterButton = ({
  ButtonContent,
  buttonProperties,
  dropdownFooter,
  filterFamily,
  isOptionsSelectDisabled,
  placement,
  property,
  value,
  onChange
}) => {
  const isRestrictedField = isFieldRestricted(property.accessLevel);
  const [isOpen, setIsOpen] = useState(false);
  const {
    resolver,
    options
  } = useQuickFilterResolverAndOptions(filterFamily, isOptionsSelectDisabled, property);
  const onOpenChange = evt => {
    setIsOpen(evt.target.value);
  };
  const referenceToOption = reference => ({
    disabled: isOptionsSelectDisabled,
    text: reference.label,
    value: reference.id
  });
  if (!resolver || !('api' in resolver)) {
    return null;
  }
  return /*#__PURE__*/_jsx(ReferenceLiteSearchSelect
  // used for rerendering options
  , {
    ButtonContent: ButtonContent,
    buttonSize: buttonProperties.BUTTON_SIZE,
    buttonUse: buttonProperties.BUTTON_USE,
    disabled: isRestrictedField || property.disabled,
    dropdownFooter: dropdownFooter,
    menuWidth: "auto",
    multi: true,
    onChange: onChange,
    onOpenChange: onOpenChange,
    open: isOpen,
    options: options,
    placement: placement,
    referenceToOption: referenceToOption,
    resolver: resolver,
    value: value
  }, isOptionsSelectDisabled ? 'external-none' : 'external-all');
};
export default ExternalOptionEnumQuickFilterButton;